import { ValidationResult } from "./models/ValidationResult";

export const isRegExMatch =
  (regEx: RegExp, errorMessage: () => string) =>
  (value: string): ValidationResult => {
    if (regEx.test(value)) {
      return { isValid: true };
    }

    return {
      isValid: false,
      errorMessage: errorMessage()
    };
  };

export const isNotRegExMatch =
  (regEx: RegExp, errorMessage: () => string) =>
  (value: string): ValidationResult => {
    if (!regEx.test(value)) {
      return { isValid: true };
    }

    return {
      isValid: false,
      errorMessage: errorMessage()
    };
  };
